import {
  useFetchedFilter,
  useFilterCustomizations,
  useFilterValues
} from 'libs/searchspring/components/collection/filters/FilterHooks'
import Icon from '@/components/snippets/icon/icon'

export function FilterButton({ filter, activeFilters, fetchedFilters, onClick }) {
  if (!filter) return null

  const fetchedFilter = useFetchedFilter(filter, fetchedFilters)
  const filterCustomizations = useFilterCustomizations(filter.field)
  const values = useFilterValues(filter, activeFilters, fetchedFilter, filterCustomizations)
  const label = filter.label
  const id = `filter-${label.toLowerCase().replace(/\s/g, '-')}`
  const activeCount = values?.filter((item) => item.checked)?.length || 0

  return (
    <button
      className="flex h-auto border-r border-neutral-medium px-1 link-fade first:pl-margin last:border-r-0"
      data-modal-parent={id}
      data-modal-role="open"
      aria-label={label}
      onClick={() => onClick(id)}
    >
      <div className="flex h-full items-center justify-center gap-x-0.5 py-0.625">
        <span className="font-heading paragraph-s font-medium uppercase !leading-none">{label}</span>
        {activeCount > 0 && (
          <span className="paragraph-xs flex aspect-1/1 w-[20px] items-center justify-center rounded-full bg-brand-neutral text-center font-medium !leading-none text-brand-black">
            {activeCount}
          </span>
        )}
        <div className={'flex size-[11px] children:size-full'}>
          <Icon id="plus" />
        </div>
      </div>
    </button>
  )
}
